import styled from "styled-components"
import Card from "@irati/ui/src/Layout/Card"
import {Label} from "@irati/ui/src/Typography"

export const StyledCard = styled(Card)`
  position: relative;
  margin-bottom: 10px;
`

export const CurrentSession = styled(Label)`
  position: absolute;
  top: 0;
  right: 0;
  margin-top: 5px;
  margin-right: 5px;
`
